import api from './api';
import authService from './auth.service.js';

const classService = {
    createClass(classData) {
      return api.post('/classes', classData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch(async (error) => {
        if (error.response?.status === 401) {
          await authService.refreshToken();
          return api.post('/classes', classData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });
        }
        throw error;
      });
    },

    updateClass(id, classData) {
      return api.put(`/classes/${id}`, classData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch(async (error) => {
        if (error.response?.status === 401) {
          await authService.refreshToken();
          return api.put(`/classes/${id}`, classData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });
        }
        throw error;
      });
    },

    getAllClasses() {
      return api.get('/classes', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch(async (error) => {
        if (error.response?.status === 401) {
          await authService.refreshToken();
          return api.get('/classes', {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });
        }
        throw error;
      });
    },

    deleteClass(id) {
      return api.delete(`/classes/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch(async (error) => {
        if (error.response?.status === 401) {
          await authService.refreshToken();
          return api.delete(`/classes/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });
        }
        throw error;
      });
    }
};

export default classService;